const doneReadGraceMs = 15 * 60 * 1000;

// Same reading as the server's csStatuses filter (back-town buildCasesVisibilitySql):
// a refresh keeps rows its page did not mention, so the rule runs on display too
const caseMatchesStatuses = (thisCase, statuses, nowMs) => {
  const {
    csClose,
    csReject,
    csCancel,
    csHandlers,
    lastRead,
    lastModified,
  } = thisCase;
  const done = Boolean(csClose) || Boolean(csReject) || (Boolean(csCancel) && (!csHandlers));

  if (!done) return statuses.includes((csHandlers) ? 'ongoing' : 'new');
  if (statuses.includes('done')) return true;
  if (!statuses.includes('doneUnread')) return false;
  if (!lastRead) return true;

  const readMs = new Date(lastRead).getTime();
  const unread = Boolean(lastModified) && (readMs < new Date(lastModified).getTime());
  return unread || (readMs >= (nowMs - doneReadGraceMs));
};

export default caseMatchesStatuses;
